module.exports = __webpack_public_path__ + "img/lv_failure_2.cf460788.png";